import EventConstituent from "./interfaces/EventConstituent";
import { IObjectKeys } from "./interfaces/ObjectKeys";

export const getKeyValue = function <T extends object, U extends keyof T>(obj: T, key: U) { return obj[key] }

export interface IDisplayValues {
    overview: IObjectKeys,
    projection: IObjectKeys,
    report: IObjectKeys,
    financial: IObjectKeys,
}
export const EventConsitutentDisplay: EventConstituent = {
    Name: "Name",
    FirstName: "First Name",
    LastName: "Last Name",
    MajorSponsor: "Major Sponsor",
    Individual: "Individual",
    Household: "Household",
    Organization: "Organization",
    Amount: "Amount",
    EventLookupId: "Event Lookup ID",
    Date: "Date",
    LookupId: "Constituent Lookup ID",
    BatchNumber: "Batch Number",
    RevenueId: "Revenue ID",
    BaseCurrencyId: "Currency ID",
};
export const EventDetailsDisplay: IDisplayValues = {
    overview: {
        EventLookupId: "Event ID",
        EventName: "Name",
        Active: "Active",
        EventCategory: "Category",
        EventType: "Type",
        Cancelled: "Cancelled",
        CancelledDate: "Cancelled Date",
        CancelledComment: "Cancelled Comment",
        EventStartDate: "Start Date",
        EventStartTime: "Start Time",
        EventEndDate: "End Date",
        EventEndTime: "End Time",
    },
    projection: {
        ProjectionEventRevenue: "Revenue",
        ProjectionMerchandiseCosts: "Merchandise Costs",
        ProjectionEventIncome: "Income",
        ProjectionMajorDonorPayments: "Major Donor Payments",
        ProjectionEventBaseIncome: "Base Income",
        ProjectionNumberOfTransactions: "Number of Transactions",
        ProjectionComments: "Comments",
    },
    report: {
        EventReportEventRevenue: "Revenue",
        EventReportMerchandiseCosts: "Merchandise Costs",
        EventReportEventIncome: "Income",
        EventReportMajorDonorPayments: "Major Donor Payments",
        EventReportEventBaseIncome: "Base Income",
        EventReportNumberOfTransactions: "Number of Transactions",
        EventReportComments: "Comments",
    },
    financial: {
        FinancialStatus: "Status",
        FinancialTicketSalesNet: "Ticket Sales Net",
        FinancialTicketSalesExpense: "Ticket Sales Expense",
        FinancialTicketArrangementsExpense: "Ticket Arrangements Expense",
        FinancialMembershipIncome: "Membership Income",
        FinancialMembershipNet: "Membership Net",
        FinancialRaffleAndGamesIncome: "Raffle and Games Income",
        FinancialRaffleAndGamesExpense: "Raffle and Games Expense",
        FinancialRaffleAndGamesNet: "Raffle and Games Net",
        FinancialLiveAuctionIncome: "Live Auction Income",
        FinancialLiveAuctionExpense: "Live Auction Expense",
        FinancialLiveAuctionNet: "Live Auction Net",
        FinancialSilentAuctionIncome: "Silent Auction Income",
        FinancialSilentAuctionExpense: "Silent Auction Expense",
        FinancialSilentAuctionNet: "Silent Auction Net",
        FinancialMiscellaneousIncome1: "Miscellaneous Income 1",
        FinancialMiscellaneousIncome2: "Miscellaneous Income 2",
        FinancialFinancialAdjustmentExpense: "Financial Adjustment Expense",
        FinancialCashUnderwriting: "Cash Underwriting",
        FinancialGrossIncome: "Gross Income",
        FinancialSubtotalExpense: "Subtotal Expense",
        FinancialNetProceeds: "Net Proceeds",
        FinancialRetainedIncomeExpense: "Retained Income Expense",
        FinancialRetainedIncomeWithheldExpense: "Retained Income Withheld Expense",
    }
}